
  import cloudflareRuntime$MrQigQjdzTfi1pMV19SqtZ50RcTgm2gF9wJXP2Reo90 from '/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import ipxRuntime$i5K1NqWkY_45UljyT7tH1_WtRc3y4434685fNnC_45qZUeE from '/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 414,
    "md": 768,
    "lg": 1024,
    "xl": 1366,
    "2xl": 1536,
    "xs": 360,
    "xxl": 1920
  },
  "presets": {
    "gameservice": {
      "baseURL": "https://media.platego.io"
    },
    "local": {
      "baseURL": "/"
    },
    "heroDev": {
      "baseURL": "https://stage.happytiger.co.uk"
    },
    "heroStage": {
      "baseURL": "https://stage.happytiger.co.uk"
    },
    "heroProd": {
      "baseURL": "https://www.happytiger.co.uk"
    }
  },
  "provider": "ipx",
  "domains": [
    "media.platego.io",
    "stage.happytiger.co.uk"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['cloudflare']: { setup: cloudflareRuntime$MrQigQjdzTfi1pMV19SqtZ50RcTgm2gF9wJXP2Reo90, defaults: {"baseURL":"https://media.platego.io","modifiers":{"quality":"64"}} },
  ['ipx']: { setup: ipxRuntime$i5K1NqWkY_45UljyT7tH1_WtRc3y4434685fNnC_45qZUeE, defaults: {} }
    }
  }
